
import { useState } from "react"
import { FiCalendar, FiClock } from "react-icons/fi"
import { Calendar } from "@/components/ui/shadcn/calendar"
import { FieldGroup, Field, FieldLabel } from "@/components/ui/shadcn/field"
import { InputGroup, InputGroupInput, InputGroupAddon } from "@/components/ui/shadcn/input-group"
import Button from "../ui/Button"
import dayjs from "dayjs"

export default function ScheduleModal({ onClose, title = "Schedule Generation" }) {
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [time, setTime] = useState(dayjs().format("HH:mm"))

    const getScheduledDateTime = () => {
        if (!selectedDate) return null
        const [hours, minutes] = time.split(':').map(Number)
        const date = new Date(selectedDate)
        date.setHours(hours, minutes, 0, 0)
        return date
    }

    const handleAccept = async () => {
        const scheduledDateTime = getScheduledDateTime()
        if (scheduledDateTime) {
            onClose(scheduledDateTime)
        }
    }

    const handleCancel = () => {
        onClose(null)
    }

    return (
        <div className='w-full max-w-[380px] rounded-md flex flex-col bg-background border border-white/10'>
            {/* Header */}
            <div className='flex justify-between py-3 px-4 border-b border-white/10 items-center'>
                <div className='flex items-center gap-2'>
                    <FiCalendar className="text-primary w-4 h-4" />
                    <span className='text-secondary-foreground text-lg font-bold'>{title}</span>
                </div>
            </div>
            
            {/* Calendar Content */}
            <div className='flex flex-col p-4'>
                <Calendar
                    mode="single"
                    selected={selectedDate}
                    onSelect={setSelectedDate}
                    disabled={(date) => date < new Date(new Date().setHours(0, 0, 0, 0))}
                    className="rounded-md w-full"
                />
                
                {/* Time Selection */}
                <FieldGroup className="mt-4">
                    <Field>
                        <FieldLabel htmlFor="schedule-time">Time</FieldLabel>
                        <InputGroup>
                            <InputGroupInput
                                id="schedule-time"
                                type="time"
                                value={time}
                                onChange={(e) => setTime(e.target.value)}
                                className="appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none"
                            />
                            <InputGroupAddon align="inline-end">
                                <FiClock className="text-muted-foreground" />
                            </InputGroupAddon>
                        </InputGroup>
                    </Field>
                </FieldGroup>
                
                {/* Selected DateTime Display */}
                {selectedDate && (
                    <div className='mt-4 px-3 py-2 bg-primary/10 rounded-md border border-primary/20 w-full'>
                        <span className='text-sm text-secondary-foreground'>
                            Scheduled: <span className="font-medium text-primary">{dayjs(getScheduledDateTime()).format('dddd, MMMM D, YYYY [at] HH:mm')}</span>
                        </span>
                    </div>
                )}
            </div>

            {/* Footer with Accept/Cancel Buttons */}
            <div className='flex justify-end p-4 pt-2 gap-3 border-t border-white/10'>
                <Button 
                    type='danger-ghost' 
                    className='min-w-20' 
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
                <Button 
                    type='primary' 
                    className='min-w-20' 
                    onClick={handleAccept}
                    disabled={!selectedDate}
                >
                    Accept
                </Button>
            </div>
        </div>
    )
}
